/* VVBETTER detail story (vvb-ds-*): reveal, count-up, ingredient explorer, before/after slider, FAQ filter, add to cart / buy now.
   Everything is readable without this script; it only adds motion and interaction. Safe to load twice. */
(() => {
  if (window.__vdsLoaded) return;
  window.__vdsLoaded = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const once = (el, key) => { if (el.dataset['vds' + key]) return false; el.dataset['vds' + key] = '1'; return true; };

  /* ---------- reveal, count-up, bars and rings (final state is already in the markup) ---------- */
  const fmt = (n, sep) => (sep ? Math.round(n).toLocaleString('en-US') : Number.isInteger(n) ? String(n) : n.toFixed(1));
  function count(el) {
    const to = parseFloat(el.dataset.vdsCount);
    if (Number.isNaN(to) || reduce) return;
    const sep = el.dataset.sep, t0 = performance.now(), d = 1500, tail = el.textContent.replace(/^[\d.,]+/, '');
    (function step(t) {
      const k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(to * e, sep) + (k < 1 ? '' : tail);
      if (k < 1) requestAnimationFrame(step); else el.textContent = fmt(to, sep) + tail;
    })(t0);
  }
  const revealIO = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const t = e.target;
    t.classList.remove('pre'); t.classList.add('in');
    $$('[data-vds-count]', t).forEach(count);
    revealIO.unobserve(t);
  }), { threshold: 0.15 });
  const playIO = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    playIO.unobserve(e.target);
  }), { threshold: 0.3 });

  function initReveal(root) {
    $$('.vds .rv', root).forEach(el => {
      if (!once(el, 'Rv')) return;
      if (el.getBoundingClientRect().top > innerHeight * 0.92) el.classList.add('pre');
      revealIO.observe(el);
    });
    $$('.vds [data-vds-in]', root).forEach(el => { if (once(el, 'In')) playIO.observe(el); });
  }

  /* ---------- ingredient explorer ---------- */
  function initExplorer(root) {
    $$('[data-vds-explorer]', root).forEach(box => {
      if (!once(box, 'Ex')) return;
      const tabs = $$('.tab', box), panels = $$('.panel', box);
      const pick = i => {
        tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
        panels.forEach((p, k) => { p.hidden = k !== i; p.classList.toggle('on', k === i); });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => pick(i));
        t.addEventListener('keydown', e => {
          const d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
          if (!d) return;
          e.preventDefault();
          const n = (i + d + tabs.length) % tabs.length;
          pick(n); tabs[n].focus();
        });
      });
    });
  }

  /* ---------- before / after ---------- */
  function initResults(root) {
    $$('[data-vds-results]', root).forEach(box => {
      if (!once(box, 'Res')) return;
      const baw = $('[data-baw]', box); if (!baw) return;
      const rng = $('input[type=range]', baw), imgB = $('img:not(.after)', baw), imgA = $('img.after', baw);
      const setPos = v => baw.style.setProperty('--pos', v + '%');
      setPos(50);
      rng.addEventListener('input', () => setPos(rng.value));
      $$('.rt', box).forEach(btn => btn.addEventListener('click', () => {
        $$('.rt', box).forEach(x => x.setAttribute('aria-selected', String(x === btn)));
        const d = btn.dataset;
        if (imgB && d.before) { imgB.removeAttribute('srcset'); imgB.src = d.before; }
        if (imgA && d.after) { imgA.removeAttribute('srcset'); imgA.src = d.after; }
        $('[data-rk]', box).textContent = d.title;
        $('[data-rn]', box).textContent = d.value;
        $('[data-rs]', box).textContent = d.sub;
        const ra = $('[data-ra]', box); if (ra) ra.style.width = (100 - parseFloat(d.value)) + '%';
        rng.value = 50; setPos(50);
      }));
    });
  }

  /* ---------- FAQ filter ---------- */
  function initFaq(root) {
    $$('[data-vds-faq]', root).forEach(box => {
      if (!once(box, 'Faq')) return;
      const chips = $$('.ct', box);
      chips.forEach(b => b.addEventListener('click', () => {
        chips.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        $$('details', box).forEach(d => { d.style.display = (b.dataset.c === 'all' || d.dataset.c === b.dataset.c) ? '' : 'none'; });
      }));
    });
  }

  /* ---------- buy buttons: reuse the theme's cart drawer ---------- */
  async function addToCart(id) {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer' }) });
    if (!r.ok) throw new Error('add failed');
    return r.json();
  }
  function initBuy(root) {
    $$('[data-vds-add]', root).forEach(btn => {
      if (!once(btn, 'Add')) return;
      btn.addEventListener('click', async () => {
        btn.setAttribute('aria-busy', 'true');
        try {
          const data = await addToCart(btn.dataset.variant);
          const cart = await (await fetch('/cart.js')).json();
          $$('[data-cart-count]').forEach(el => el.setAttribute('data-cart-count', cart.item_count));
          $('.layout--viewport')?.setAttribute('data-cart-empty', String(cart.item_count === 0));
          if (window.trigger) {
            Object.entries(data.sections || {}).forEach(([key, html]) => window.trigger('theme:cart:' + key.replace(/^cart-/, '') + ':updateHtml', { section: html, load_transitions: true }));
            setTimeout(() => window.trigger('theme:cart:open'), 250);
          } else { location.href = '/cart'; }
        } catch (e) { location.href = '/cart/' + btn.dataset.variant + ':1'; }
        finally { btn.removeAttribute('aria-busy'); }
      });
    });
    $$('[data-vds-buy]', root).forEach(btn => {
      if (!once(btn, 'Buy')) return;
      btn.addEventListener('click', async () => {
        btn.setAttribute('aria-busy', 'true');
        try { await addToCart(btn.dataset.variant); location.href = '/checkout'; }
        catch (e) { location.href = '/cart/' + btn.dataset.variant + ':1'; }
      });
    });
  }

  function init(root = document) { initReveal(root); initExplorer(root); initResults(root); initFaq(root); initBuy(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
